var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.14286C0 0.95939 0.95939 0 2.14286 0H12.1429C13.3263 0 14.2857 0.95939 14.2857 2.14286V4.91233C13.7105 5.37289 13.3299 6.04361 13.2366 6.78569H8.21429C6.43909 6.78569 5 8.22476 5 9.99997C5 11.7752 6.43909 13.2143 8.21429 13.2143H13.2366C13.3299 13.9563 13.7105 14.6271 14.2857 15.0877V17.8571C14.2857 19.0406 13.3263 20 12.1429 20H2.14286C0.95939 20 0 19.0406 0 17.8571V2.14286ZM15.6614 6.15301C15.261 6.31886 15 6.70954 15 7.14289V8.57146H8.21429C7.42531 8.57146 6.78571 9.21106 6.78571 10C6.78571 10.789 7.42531 11.4286 8.21429 11.4286H15V12.8572C15 13.2905 15.261 13.6812 15.6614 13.847C16.0617 14.0129 16.5226 13.9212 16.829 13.6148L19.6861 10.7576C20.1046 10.3392 20.1046 9.66083 19.6861 9.24241L16.829 6.38527C16.5226 6.07884 16.0617 5.98719 15.6614 6.15301Z",
    fill: "#B5B9BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.27fd30438ea38ce100b18bc37fdb6a8f.svg";
export { ForwardRef as ReactComponent };